<template>
  <div class="row">
    <input
      type="text"
      class="col-10"
      v-model="entity[currentField]"
    />
    <div class="col-2" style="text-align: right">
      <core-drop-down
        :items="languages"
        v-if="languages.length"
        selectClass="ml-3 right-chevron select-language"
        noWrapper
        labelAttribute="code"
        valueAttribute="code"
        :selectedValue.sync=currentLangCode
      ></core-drop-down>
    </div>
  </div>
</template>

<script>
import Language from '@/services/hatsApi/Language'

export default {
  props: {
    fieldName: {
      type: String,
      default: 'name'
    },
    languageId: {
      type: [Number, String]
    },
    entity: {
      type: [Object]
    }
  },
  data () {
    return {
      currentLang: {},
      currentLangCode: this.$i18n.locale.toUpperCase(),
      languages: []
    }
  },
  computed: {
    currentField () {
      return (this.fieldName + '_' + this.currentLangCode)
    }
  },
  async created () {
    try {
      let languageResponse = await Language.getLanguages()
      if (languageResponse.data.success) {
        this.languages = languageResponse.data.data
        this.languages.forEach((elm) => {
          if (this.languageId === elm.id || (!this.languageId && elm.code === this.$i18n.locale.toUpperCase())) {
            this.currentLang = elm
            this.currentLangCode = elm.code
          }
        })
      }
    } catch (error) {
      console.error(error)
    }
  },
  watch: {
    currentLangCode: {
      handler (val) {
        if (val && !(typeof val === 'string' || val instanceof String)) {
          this.currentLangCode = val.code
          return
        }
        this.languages.forEach((elm) => {
          if (val === elm.code) {
            this.currentLang = elm
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/LangFieldEditor.vue